export class PacienteDTO {

    id: number = 0;

    nome: string = '';

    responsavel: string = '';

    cpf: string = '';

    foneResidencial: string = '';

    foneCelular: string = '';

    dataNascimento: Date = new Date();

    horarios: Array<string> = [];

    constructor() {
    }
}
